<!-- this component is used to check mobile fitting coverage, and redirects to fitted nationally -->
<template>
    <div class="location-coverage my-4">
        <VeeForm :validation-schema="postcodeValidationSchema" v-slot="{ handleSubmit, errors }" as="div" class="w-auto d-block d-sm-inline-block rounded">
            <form class="postcode-form d-sm-flex align-items-center" @submit="handleSubmit($event, onPostcodeSubmit)" method="post" :action="this.baseUrl + '/fitted-nationally'">
                <div class="d-block d-sm-inline-block mb-2 mb-sm-0 me-sm-3">
                    <Popper :content="errors.postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.postcode ? true : false">
                        <Field name="postcode" type="text" class="form-control postcode text-center text-sm-start" :value="postcode" placeholder="Postcode" />
                    </Popper>
                </div>
                <div class="d-block d-sm-inline-block">
                    <button type="submit" class="btn btn-sm btn-primary w-100">
                        Check coverage
                    </button>
                </div>
            </form>
        </VeeForm>
    </div>
</template>

<script>
    import { Form as VeeForm, Field } from 'vee-validate';
    import * as yup from 'yup';
    import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';

    export default {
        props: [
            'postcode', 
            'base',
            'mobile'
        ],
        components: {
            VeeForm,
            Field
        },
        data() {
            const postcodeValidationSchema = yup.object({
                'postcode': yup.string().required('postcode is a required field')
            });

            return {
                postcodeValidationSchema
            }
        },
        mounted() {
            if(this.mobile == true) {
                this.setMobileFittingLanding();
            }
        },
        methods: {
            async setMobileFittingLanding() {
                var response = await axios.post('/ajax/set_mobile_fitting');
            },
            onPostcodeSubmit(values) {
                this.emitter.emit('isLoading', true);
                var postcode = values.postcode;
                
                //TO DO - check postcode is valid
                void navigateWithAttribution(this.base + postcode, { replace: true });
            },
        }
    }
</script>

<style lang="scss" scoped>
    
</style>